import React, { Component } from 'react';
import styled from 'styled-components';

import { PrestoAppTheme, PrestoAppComponents } from 'presto-mini-apps-lib';

import connectPage from '../../scenes/Main/index';
import PageWrapper from '../../components/PageWrapper';
import Tabber from '../../components/Tabber';
import PaymentDetails from '../../components/PaymentDetails';
import TextInputWithLabel from '../../components/TextInputWithLabel';

import Routes from '../../constants/routes';
import { 
    PayOptionTabList,
    ButtonHeight,
    isMobile
} from '../../constants/appState';
import { ErrorCode } from '../../constants/statusCode';
import {
    title_loginPay,
    term_mobile,
    phrase_MobilePlaceholderText,
    // phrase_MobilePreText,
    phrase_MobileErrorMessage,
    term_password,
    phrase_PasswordPlaceholderText,
    term_email,
    phrase_EmailPlaceholderText,
    phrase_EmailErrorMessage,
    term_login,
    term_select_other_login_methods,
    term_otp,
    term_transaction_pin,
    phrase_PINLoginErrorMessage,
    phrase_OTPLoginErrorMessage,
    phrase_OTPMobileErrorMessage
} from '../../constants/text';
import { appService } from '../../services';
import LoginMethodModal from '../../components/LoginMethodModal';
import DigitInputWithLabel from '../../components/DigitInputWithLabel';

  

class Login extends Component {
    pageName;

    constructor(props) {
        super(props);

        this.pageName = Routes.LOGINPAY;
        this.smsOtpInput = null;
        this.timeout = null;
        this.state = {
            isFormError: true,
            isFormTouched: false,
            formLoginTryCount: 0,
            currentMethod: 'mobile',
            clearField: false,
            countryCodeList: [],
            formValue: {
                loginMethod: 'SMS',
                mobile: '',
                mobileError: false,
                mobileErrorMessage: '',
                mobileCountryCode: '60',
                email: '',
                emailError: false,
                password: '',
                passwordError: false,
                passwordPolicyMismatch: false,
                pinError: false,
                smsOtpError: false,
            },
            isGuest: false,
            finishLoad: false,
            showLoginMethodDialog: false,
            isMobileValid: false,
            }
        }

    componentDidMount() {
        const { mainProps } = this.props;
        // Do not show the page if it is trying to register as guest
        if (!mainProps.transactionState.allowGuestPayment || !mainProps.appState.isSkipLogin) {
            this.setState({
                finishLoad: true
            });
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timeout);
    }

    onInputStateChangeHandler = (val, elmName) => {
        this.setState({
            formValue: {
                ...this.state.formValue,
                [elmName]: val 
            }
        }, this.checkForm);
    };

    onPasswordChangeHandler = (val) => {
        this.setState({
            formValue: {
                ...this.state.formValue,
                password: val 
            }
        }, this.checkForm);
    };

    onRequestLoginOtpHandler = (otpCallback) => {
        const { mainProps, actionHandler } = this.props;
        const { formValue } = this.state;

        actionHandler.setIsLoading(true);

        this.setState({
            formValue: {
                ...this.state.formValue,
                mobileError: false,
                passwordError: false,
                pinError: false,
                smsOtpError: false,
            }
        });

        appService.apiLoginOtp({
            paymentCode: mainProps.transactionState.paymentCode,
            mobileNum: formValue.mobile.replace(/^0+/, ''),
            mobileCountryCode: formValue.mobileCountryCode,
            onSuccess: (resp) => this.onRequestLoginOtpSuccessHandler(resp, otpCallback),
            onError: (resp) => this.onRequestLoginOtpFailedHandler(resp, otpCallback),
        });
    };

    onRequestLoginOtpSuccessHandler = (resp, otpCallback) => {
        const { actionHandler } = this.props;
        const { formValue } = this.state;
        actionHandler.setIsLoading(false);

        otpCallback(resp);

        if (this.smsOtpInput) {
            if (formValue.password && formValue.password.length > 0) {
                this.smsOtpInput.clear();
            }
            this.smsOtpInput.focus();
        }
    };

    onRequestLoginOtpFailedHandler = (resp, otpCallback) => {
        const { actionHandler } = this.props;
        const { formValue } = this.state;
        actionHandler.setIsLoading(false);

        switch(+resp.errorCode) {
            case ErrorCode.MOBILE_NOT_REGISTERED:
                this.setState({
                    formValue: {
                        ...this.state.formValue,
                        mobileError: formValue.mobile !== ''
                    }
                });
                break;
            case ErrorCode.OTP_EXCEEDED_DAILY_MAX_RESEND_ERROR:
                this.setState({
                    formValue: {
                        ...this.state.formValue,
                        mobileError: formValue.mobile !== '',
                        mobileErrorMessage: resp.errorMsg
                    }
                });
                break;
            case ErrorCode.OTP_REQUEST_TIMEOUT_ERROR:
                this.setState({
                    formValue: {
                        ...this.state.formValue,
                        mobileError: formValue.mobile !== '',
                        mobileErrorMessage: resp.errorMsg
                    }
                });
                break;
            default:
                // do nothing;
        }

        otpCallback(resp);
    };

    onSubmitHandler = (e) => {
        e.preventDefault();

        const { formValue, formLoginTryCount, isFormError } = this.state;
        const { mainProps, actionHandler } = this.props;

        if (!isFormError) {
            actionHandler.setIsLoading(true);
            mainProps.setStopQueryPolling(true);

            this.setState({
                isFormTouched: true,
                formLoginTryCount: formLoginTryCount + 1
            }, this.checkForm);

            appService.apiLogin({
                paymentCode: mainProps.transactionState.paymentCode,
                loginMethod: formValue.loginMethod,
                mobileNum: formValue.mobile.replace(/^0+/, ''),
                mobileCountryCode: (!!formValue.email && formValue.email !== '' ? '' : formValue.mobileCountryCode),
                email: formValue.email,
                password: formValue.password,
                onSuccess: this.onSubmitSuccessHandler,
                onError: this.onSubmitFailedHandler,
            });
        }
    };

    onSubmitSuccessHandler = (resp) => {
        const { mainProps, actionHandler } = this.props;
        mainProps.setStopQueryPolling(false);
        actionHandler.setIsLoading(false);

        if(!!resp.success) {
            const { formValue, isGuest } = this.state;

            actionHandler.updatePaymentData(resp.data);
            actionHandler.updateLoginData(formValue);
            actionHandler.setIsGuest(isGuest);
            if (resp.data.requireOtp) {
                actionHandler.changePageHandler(Routes.TXN_PIN);
            } else {
                actionHandler.changePageHandler(Routes.PAYMENT);
            }
        } else {
            // NOTE: not sure what happen, so just redirect to error page
            actionHandler.setDefaultError(true);
        }
    };

    onSubmitFailedHandler = (data) => {
        const { 
            actionHandler, 
            mainProps 
        } = this.props;
        const { formLoginTryCount } = this.state;
        const {
            formValue
        } = this.state;

        mainProps.setStopQueryPolling(false);
        actionHandler.setIsLoading(false);
        this.checkForm();

        if(formLoginTryCount >= +mainProps.transactionState.maxLoginTries) {
            actionHandler.setMaxLoginTriesReached(true);
            return;
        }

        switch(+data.errorCode) {
            case ErrorCode.MOBILE_NOT_REGISTERED:
                this.setState({
                    formValue: {
                        ...this.state.formValue,
                        mobileError: formValue.mobile !== '',
                        emailError: formValue.email !== '',
                    }
                });
                break;
            case ErrorCode.INVALID_CREDENTIAL:
            case ErrorCode.INVALID_CREDENTIAL_PW:
                this.setState({
                    formValue: {
                        ...this.state.formValue,
                        passwordError: this.state.formValue.loginMethod === 'PASS' ? true : false,
                        pinError: this.state.formValue.loginMethod === 'PIN' ? true : false,
                        smsOtpError: this.state.formValue.loginMethod === 'SMS' ? true : false,
                        passwordPolicyMismatch: false,
                    }
                });
                break;
            case ErrorCode.PASSWORD_POLICY_UNMATCHED:
                this.setState({
                    formValue: {
                        ...this.state.formValue,
                        passwordError: this.state.formValue.loginMethod === 'PASS' ? true : false,
                        pinError: this.state.formValue.loginMethod === 'PIN' ? true : false,
                        smsOtpError: this.state.formValue.loginMethod === 'SMS' ? true : false,
                        passwordPolicyMismatch: true,
                    }
                });
                break;
            default:
                actionHandler.setDefaultError(true);
        }
    };

    onCountryCodeChange = (areaCode) => {
        this.setState({
            formValue: {
                ...this.state.formValue,
                mobileCountryCode: areaCode, 
            }
        });
    };

    checkForm = () => {
        const {
            mainProps
        } = this.props;

        this.timeout = setTimeout(() => {
            const { formValue, currentMethod } = this.state;
            if (formValue.loginMethod === 'SMS' || formValue.loginMethod === 'PIN') {
                this.setState({
                    isFormError: (
                        formValue.mobile === ''  ||
                        formValue.password === '' ||
                        formValue.mobile.length < 8 ||
                        formValue.password.length < 6 ||
                        mainProps.appState.isLoading
                    ),
                    isMobileValid: (formValue.mobile !== '' && formValue.mobile.length >= 8)
                });
            } else {
                this.setState({
                    isFormError: (
                        (currentMethod === 'mobile' 
                            ? formValue.mobile === '' 
                            : formValue.email === ''
                        ) ||
                        formValue.password === '' ||
                        (currentMethod === 'mobile' 
                            ? formValue.mobile.length < 8 
                            : !this.isValidEmail()
                        ) ||
                        formValue.password.length < 8 ||
                        mainProps.appState.isLoading
                    ),
                    isMobileValid: false
                });
            }
        }, 0);
    };

    isValidEmail = () => {
        const { formValue } = this.state;
        var emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/;
        return emailRegex.test(formValue.email);
    };

    changeMethod = (e) => {
        e.preventDefault();

        const { currentMethod } = this.state;
        this.setState({ 
            currentMethod: (currentMethod === 'mobile' ? 'email' : 'mobile'), 
            clearField: true,
        }, () => {
            this.setState({ 
                formValue: {
                    ...this.state.formValue,
                    mobile: '', 
                    email: '',
                },
                clearField: false, 
            }, this.checkForm); 
        });
    };

    onLoginMethodDialogOpen = () => {
        this.setState({showLoginMethodDialog: true})
    };

    onLoginMethodDialogClose = () => {
        this.setState({showLoginMethodDialog: false})
    };

    onLoginMethodSelected = (loginMethod) => {
        this.setState({
            showLoginMethodDialog: false,
            formValue: {
                ...this.state.formValue,
                loginMethod: loginMethod, 
                password: '',
                passwordError: false,
                pinError: false,
                smsOtpError: false,
                mobileError: false,
            }
        });
    };

    render() {
        const {
            isFormError,
            formValue,
            currentMethod,
            clearField,
            finishLoad,
            showLoginMethodDialog,
            isMobileValid,
        } = this.state;

        const {loginMethod} = formValue;

        const { mainProps, actionHandler } = this.props;

        return (
            <PageWrapper showRedirectLink>
                <LoginWrapper className="page-login">
                    { finishLoad && (
                        <>
                            { !isMobile() ? (
                                <Tabber
                                    currentActiveTab={PayOptionTabList[1].id}
                                    tabList={PayOptionTabList}
                                    clickHandler={actionHandler.changePageHandler}
                                />
                            ) : null}

                            <PaymentDetails
                                payAmount={mainProps.transactionState.paymentAmount}
                                paymentDetails={mainProps.transactionState.paymentDescription}
                                itemList={mainProps.transactionState.paymentItemList}
                                appState={mainProps.appState}
                            />

                            <div className="login-component">
                                <h3>{title_loginPay}</h3>
                                <form className="login-form" onSubmit={(e) => e.preventDefault()}>
                                    { currentMethod === 'mobile' ? (<>
                                        <TextInputWithLabel
                                            label={term_mobile}
                                            inputName="mobile"
                                            type="number"
                                            placeholderText={phrase_MobilePlaceholderText}
                                            // preText={phrase_MobilePreText}
                                            hasCountrySelector={true}
                                            countrySelectorDefaultCode={formValue.mobileCountryCode}
                                            countrySelectorOnChange={this.onCountryCodeChange}
                                            inputStateChangeHandler={this.onInputStateChangeHandler}
                                            withOtp={loginMethod === 'SMS'}
                                            enableOtp={isMobileValid}
                                            requestOtpHandler={this.onRequestLoginOtpHandler}
                                            maxLength={12}
											errorMessage={
											        loginMethod === 'SMS'
											            ? formValue.mobileErrorMessage || phrase_OTPMobileErrorMessage
											            : formValue.mobileErrorMessage || phrase_MobileErrorMessage
											}
											isError={formValue.mobileError}
                                            clearField={clearField}
                                            enterTrigger={this.onSubmitHandler}
                                        />

                                        {/*<div className="method-cta">*/}
                                            {/*<button className="link" onClick={this.changeMethod}>Use Email</button>*/}
                                        {/*</div>*/}
                                    </>) : (<>
                                        <TextInputWithLabel
                                            label={term_email}
                                            inputName="email"
                                            type="email"
                                            placeholderText={phrase_EmailPlaceholderText}
                                            inputStateChangeHandler={this.onInputStateChangeHandler}
                                            errorMessage={phrase_EmailErrorMessage}
                                            isError={formValue.emailError}
                                            clearField={clearField}
                                            enterTrigger={this.onSubmitHandler}
                                        />
                                        {/*<div className="method-cta">*/}
                                            {/*<button className="link" onClick={this.changeMethod}>Use Mobile Number</button>*/}
                                        {/*</div>*/}
                                    </>) }
                                    {loginMethod === 'PASS' && (
                                        <TextInputWithLabel
                                            label={term_password}
                                            inputName="password"
                                            type="password"
                                            placeholderText={phrase_PasswordPlaceholderText}
                                            inputStateChangeHandler={this.onInputStateChangeHandler}
                                            maxLength={30}
                                            errorMessage={phrase_MobileErrorMessage}
                                            isError={formValue.passwordError}
                                            enterTrigger={this.onSubmitHandler}
                                        />
                                    )}

                                    {loginMethod === 'SMS' && (
                                        <DigitInputWithLabel
                                            ref={n => (this.smsOtpInput = n)}
                                            initialValue=""
                                            length={6}
                                            label={term_otp}
                                            inputName="password"
                                            type="password"
                                            onChange={this.onPasswordChangeHandler}
                                            errorMessage={phrase_OTPLoginErrorMessage}
                                            isError={formValue.smsOtpError}
                                            enterTrigger={this.onSubmitHandler}
                                        />
                                    )}

                                    {loginMethod === 'PIN' && (
                                        <DigitInputWithLabel
                                            initialValue=""
                                            length={6}
                                            label={term_transaction_pin}
                                            inputName="password"
                                            type="password"
                                            onChange={this.onPasswordChangeHandler}
                                            errorMessage={phrase_PINLoginErrorMessage}
                                            isError={formValue.pinError}
                                            enterTrigger={this.onSubmitHandler}
                                        />
                                    )}
                                    
                                    <PrestoAppComponents.Button
                                        height={ButtonHeight+'px'}
                                        className="login-button"
                                        disabled={isFormError}
                                        onClick={this.onSubmitHandler}
                                    >{term_login}</PrestoAppComponents.Button>

                                    <LoginMethodLinkWrapper>
                                        <span className="link" onClick={this.onLoginMethodDialogOpen}>{term_select_other_login_methods}</span>
                                    </LoginMethodLinkWrapper>

                                </form>
                            </div>
                            <LoginMethodModal 
                                selectMethod={loginMethod}
                                isOpen={showLoginMethodDialog} 
                                onClose={this.onLoginMethodDialogClose} 
                                onSelected={this.onLoginMethodSelected} />
                        </>
                    )}
                </LoginWrapper>
            </PageWrapper>
        );
    }
}

export default connectPage(Login);


const LoginWrapper = styled.div`
    & .login-component {
        padding: 0 ${PrestoAppTheme.layout.smallGap} ${PrestoAppTheme.layout.smallGap};

        & > h3 {
            margin: 0 0 ${PrestoAppTheme.layout.commonGap};
            font-size: 1.5rem;
            font-weight: 500;
        }

        & .login-button{
            &[disabled] {
                background-color: rgba(${PrestoAppTheme.colors.prestoRedRGB}, .4);
            }
        }

        & .method-cta {
            margin-top: -0.5em;
            text-align: right;

            & button.link {
                padding: 0;
                border: 0;
                font-family: inherit;
                font-size: inherit;
                color: ${PrestoAppTheme.colors.baseBlue};
                background: transparent;
                cursor: pointer;

                &:focus {
                    outline: 0;
                }
            }
        }
    }
`;

const LoginMethodLinkWrapper = styled.div`
    padding: ${PrestoAppTheme.layout.commonGap} 0;
    text-align: center;

    & .link {
        font-weight: 400;
        font-size: ${PrestoAppTheme.layout.fontSizeXSmall};
        color: ${PrestoAppTheme.colors.baseBlue};
        cursor: pointer;
    }
`;